import type { commonInput, overviewPageInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetDashboardCommon: commonInput;
	useGetDashboardOverview: overviewPageInput;
}

const DASHBOARD_SERVICE_KEYS = createReactQueryKeys<Keys>("dashboard", [
	"useGetDashboardCommon",
	"useGetDashboardOverview",
]);

export { DASHBOARD_SERVICE_KEYS };
